<template>
  <slot />
  <Teleport v-if="rendering" :to="host">
    <FinderMapSurface
      :records="records"
      :kind="kind"
      :payload="payload"
      :settings="settings"
      :card-settings="cardSettings"
      :selection="selection"
      :commands="commands"
      :loading="loading"
      :params="params"
      :generation="generation"
      :mode="mode"
    />
  </Teleport>
  <Teleport v-if="mobileRendering" :to="host"
    ><FinderMapMobileOverlay :result="selected" :settings="settings" :commands="commands"
  /></Teleport>
</template>

<script setup>
import { useFinderMapApp } from "#ce/apps/SpFinderMap/composables/useFinderMapApp";
import FinderMapMobileOverlay from "#ce/apps/SpFinderMap/components/FinderMapMobileOverlay.ce.vue";
import FinderMapSurface from "#ce/apps/SpFinderMap/components/FinderMapSurface.ce.vue";
const {
  host,
  records,
  kind,
  payload,
  settings,
  cardSettings,
  selection,
  commands,
  loading,
  params,
  generation,
  mode,
  selected,
  rendering,
  mobileRendering,
} = useFinderMapApp();
</script>

<style>
:host {
  display: block;
}
</style>
